<template>
  <FusionPublicPage />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PublicHome'
})
</script>
